import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { LOCAL_STORAGE_KEYS } from './constants';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private initialized = false;

  init(): void {
    if (this.initialized || !environment.gaMeasurementId) {
      return;
    }

    const measurementId = environment.gaMeasurementId;

    // Load gtag.js script dynamically
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    // Initialize dataLayer and gtag function
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', measurementId,{user_id: JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER) ?? 'null')?.user_id});

    this.initialized = true;
  }
}
